import React from "react";
import { FaqQuestionsComponent } from "./components/faq-questions.component";
import { FaqTitleComponent } from "./components/faq-title.component";

interface IFaqContainerComponentProps { }

export const FaqContainerComponent: React.FC<IFaqContainerComponentProps> = (
    props: IFaqContainerComponentProps
) => {
    return (
        <section id="faq" className="faq section">
            <div className="container-fluid">
                <div className="row gy-4">
                    <div className="col-lg-7 d-flex flex-column justify-content-center order-2 order-lg-1">
                        <FaqTitleComponent />
                        <FaqQuestionsComponent />
                    </div>

                    <div className="col-lg-5 order-1 order-lg-2">
                        <img loading="lazy"
                            src="/assets/img/faq.jpg"
                            className="img-fluid border-radius-10px"
                            alt="faq-image"
                            data-aos="zoom-in"
                            data-aos-delay="100"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};
